package com.rajen.angrejidictionary.data.local

import kotlinx.browser.localStorage

object DeviceIdManager {
    private const val KEY = "ad_device_id"

    fun getDeviceId(): String = try {
        localStorage.getItem(KEY)
            ?: js("crypto.randomUUID()").unsafeCast<String>()
                .also { localStorage.setItem(KEY, it) }
    } catch (_: Throwable) {
        "" // storage blocked: server falls back to IP + User-Agent
    }
}